/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Fulltime8Inputs */

const en_job_form_enum_fulltime8 = /** @type {(inputs: Job_Form_Enum_Fulltime8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full-time`)
};

const de_job_form_enum_fulltime8 = /** @type {(inputs: Job_Form_Enum_Fulltime8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollzeit`)
};

/**
* | output |
* | --- |
* | "Full-time" |
*
* @param {Job_Form_Enum_Fulltime8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_fulltime8 = /** @type {((inputs?: Job_Form_Enum_Fulltime8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Fulltime8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_fulltime8(inputs)
	return en_job_form_enum_fulltime8(inputs)
});
export { job_form_enum_fulltime8 as "job_form_enum_FULLTIME" }